const functionalAreaIimjobs = [
    {
    "id": "1",
    "value": "Accounting / Taxation / Audit",
    "cat_id": 8
    },
    {
    "id": "7",
    "value": "Administration",
    "cat_id": 8
    },
    {
    "id": "99",
    "value": "Analytical Chemistry",
    "cat_id": 9
    },
    {
    "id": "2",
    "value": "Analytics & Business Intelligence",
    "cat_id": 8
    },
    {
    "id": "56",
    "value": "Anesthetist",
    "cat_id": 10
    },
    {
    "id": "3",
    "value": "Banking / Financial Services",
    "cat_id": 8
    },
    {
    "id": "88",
    "value": "Bio-statistician",
    "cat_id": 9
    },
    {
    "id": "101",
    "value": "Bio/Pharma Informatics",
    "cat_id": 9
    },
    {
    "id": "97",
    "value": "Biochemist",
    "cat_id": 9
    },
    {
    "id": "87",
    "value": "Biometrician",
    "cat_id": 9
    },
    {
    "id": "103",
    "value": "Biotech Research",
    "cat_id": 9
    },
    {
    "id": "54",
    "value": "Blood Bank Officer",
    "cat_id": 10
    },
    {
    "id": "57",
    "value": "Cardiologist",
    "cat_id": 10
    },
    {
    "id": "47",
    "value": "Cardiothoracic Surgeon",
    "cat_id": 10
    },
    {
    "id": "100",
    "value": "Chemical Research",
    "cat_id": 9
    },
    {
    "id": "89",
    "value": "Clinical Data",
    "cat_id": 9
    },
    {
    "id": "98",
    "value": "Clinical Research",
    "cat_id": 9
    },
    {
    "id": "108",
    "value": "Clinical Trial Manager",
    "cat_id": 9
    },
    {
    "id": "22",
    "value": "Content Writer/ Editors",
    "cat_id": 8
    },
    {
    "id": "4",
    "value": "Corporate Planning / Consulting / Strategy",
    "cat_id": 8
    },
    {
    "id": "90",
    "value": "CRF/EDC Designer",
    "cat_id": 9
    },
    {
    "id": "73",
    "value": "Dental",
    "cat_id": 10
    },
    {
    "id": "55",
    "value": "Dentist",
    "cat_id": 10
    },
    {
    "id": "58",
    "value": "Dermatologist",
    "cat_id": 10
    },
    {
    "id": "31",
    "value": "Design",
    "cat_id": 8
    },
    {
    "id": "74",
    "value": "Diet/Nutrition",
    "cat_id": 10
    },
    {
    "id": "94",
    "value": "Drug Safety",
    "cat_id": 9
    },
    {
    "id": "28",
    "value": "Education / Language Specialist",
    "cat_id": 8
    },
    {
    "id": "59",
    "value": "ENT Specialist",
    "cat_id": 10
    },
    {
    "id": "23",
    "value": "Entrepreneur / Businessman / Outside Management Consultant",
    "cat_id": 8
    },
    {
    "id": "79",
    "value": "Epidemiologist",
    "cat_id": 10
    },
    {
    "id": "24",
    "value": "Executive Assistant/Personal Secretary",
    "cat_id": 8
    },
    {
    "id": "5",
    "value": "Export / Import / Merchandising",
    "cat_id": 8
    },
    {
    "id": "76",
    "value": "Formulation Scientist",
    "cat_id": 10
    },
    {
    "id": "38",
    "value": "General Physician/Doctor",
    "cat_id": 10
    },
    {
    "id": "44",
    "value": "General Surgeon",
    "cat_id": 10
    },
    {
    "id": "80",
    "value": "Genetic Counselor",
    "cat_id": 10
    },
    {
    "id": "60",
    "value": "Gynaecologist",
    "cat_id": 10
    },
    {
    "id": "52",
    "value": "Gynecologic Surgeon",
    "cat_id": 10
    },
    {
    "id": "107",
    "value": "Health Economist",
    "cat_id": 9
    },
    {
    "id": "61",
    "value": "Hepatologist",
    "cat_id": 10
    },
    {
    "id": "77",
    "value": "Hospital Administrator",
    "cat_id": 10
    },
    {
    "id": "25",
    "value": "Hotels / Restaurant Management",
    "cat_id": 8
    },
    {
    "id": "6",
    "value": "HR / IR",
    "cat_id": 8
    },
    {
    "id": "82",
    "value": "Infectious Disease Specialist",
    "cat_id": 10
    },
    {
    "id": "21",
    "value": "Instructional Designer",
    "cat_id": 8
    },
    {
    "id": "9",
    "value": "Insurance",
    "cat_id": 8
    },
    {
    "id": "8",
    "value": "IT",
    "cat_id": 8
    },
    {
    "id": "10",
    "value": "ITeS / BPO / Customer Service",
    "cat_id": 8
    },
    {
    "id": "12",
    "value": "KPO / Research",
    "cat_id": 8
    },
    {
    "id": "11",
    "value": "Legal / Law / Company Secretary",
    "cat_id": 8
    },
    {
    "id": "95",
    "value": "Literature Survey",
    "cat_id": 9
    },
    {
    "id": "13",
    "value": "Marketing / Advertising / Public Relations",
    "cat_id": 8
    },
    {
    "id": "14",
    "value": "Media / Entertainment",
    "cat_id": 8
    },
    {
    "id": "71",
    "value": "Medical Advisor",
    "cat_id": 10
    },
    {
    "id": "43",
    "value": "Medical Professor",
    "cat_id": 10
    },
    {
    "id": "86",
    "value": "Medical Rep",
    "cat_id": 9
    },
    {
    "id": "106",
    "value": "Medical Writer",
    "cat_id": 9
    },
    {
    "id": "109",
    "value": "Microbiologist",
    "cat_id": 9
    },
    {
    "id": "36",
    "value": "Miscellaneous",
    "cat_id": 8
    },
    {
    "id": "102",
    "value": "Molecular Biology",
    "cat_id": 9
    },
    {
    "id": "62",
    "value": "Nephrologist",
    "cat_id": 10
    },
    {
    "id": "45",
    "value": "Neuro Surgeon",
    "cat_id": 10
    },
    {
    "id": "63",
    "value": "Neurologist",
    "cat_id": 10
    },
    {
    "id": "35",
    "value": "NGO/Social Services/CSR",
    "cat_id": 8
    },
    {
    "id": "72",
    "value": "Nursing",
    "cat_id": 10
    },
    {
    "id": "64",
    "value": "Oncologist",
    "cat_id": 10
    },
    {
    "id": "81",
    "value": "Oncology Research Scientist",
    "cat_id": 10
    },
    {
    "id": "50",
    "value": "Ophthalmic Surgeon",
    "cat_id": 10
    },
    {
    "id": "65",
    "value": "Ophthamologist",
    "cat_id": 10
    },
    {
    "id": "66",
    "value": "Orthopaedist",
    "cat_id": 10
    },
    {
    "id": "46",
    "value": "Orthopedic Surgeon",
    "cat_id": 10
    },
    {
    "id": "20",
    "value": "Other",
    "cat_id": 8
    },
    {
    "id": "84",
    "value": "Other Healthcare Role",
    "cat_id": 10
    },
    {
    "id": "110",
    "value": "Other Pharma Role",
    "cat_id": 9
    },
    {
    "id": "67",
    "value": "Pathologist",
    "cat_id": 10
    },
    {
    "id": "51",
    "value": "Pediatric Surgeon",
    "cat_id": 10
    },
    {
    "id": "68",
    "value": "Pediatrician",
    "cat_id": 10
    },
    {
    "id": "16",
    "value": "Pharma / Biotech / Healthcare / Medical / R&D",
    "cat_id": 8
    },
    {
    "id": "85",
    "value": "Pharmacist/Chemist/Biochemist",
    "cat_id": 9
    },
    {
    "id": "105",
    "value": "Pharmacovigilance Specialist",
    "cat_id": 9
    },
    {
    "id": "96",
    "value": "Pharmacy",
    "cat_id": 9
    },
    {
    "id": "39",
    "value": "Physician - Ayurvedic Medicine",
    "cat_id": 10
    },
    {
    "id": "40",
    "value": "Physician - Herbal Medicine",
    "cat_id": 10
    },
    {
    "id": "41",
    "value": "Physician - Homeopathy",
    "cat_id": 10
    },
    {
    "id": "42",
    "value": "Physician - Unani Medicine",
    "cat_id": 10
    },
    {
    "id": "75",
    "value": "Physiotherapy",
    "cat_id": 10
    },
    {
    "id": "33",
    "value": "Presales/RFP",
    "cat_id": 8
    },
    {
    "id": "37",
    "value": "Product Management",
    "cat_id": 8
    },
    {
    "id": "17",
    "value": "Production / Maintenance / Quality Assurance",
    "cat_id": 8
    },
    {
    "id": "69",
    "value": "Psychiatrist",
    "cat_id": 10
    },
    {
    "id": "78",
    "value": "Public Health Specialist",
    "cat_id": 10
    },
    {
    "id": "18",
    "value": "Purchase / Supply Chain / Logistics",
    "cat_id": 8
    },
    {
    "id": "93",
    "value": "Quality Audit",
    "cat_id": 9
    },
    {
    "id": "70",
    "value": "Radiologist",
    "cat_id": 10
    },
    {
    "id": "34",
    "value": "Real Estate/Construction",
    "cat_id": 8
    },
    {
    "id": "104",
    "value": "Regulatory Affairs Specialist",
    "cat_id": 9
    },
    {
    "id": "92",
    "value": "Research",
    "cat_id": 9
    },
    {
    "id": "26",
    "value": "Research & Development",
    "cat_id": 8
    },
    {
    "id": "15",
    "value": "Sales / Business Development / Client Servicing",
    "cat_id": 8
    },
    {
    "id": "91",
    "value": "Statistical Analysis",
    "cat_id": 9
    },
    {
    "id": "53",
    "value": "Surgeon - Other",
    "cat_id": 10
    },
    {
    "id": "83",
    "value": "Telemedicine Specialist",
    "cat_id": 10
    },
    {
    "id": "29",
    "value": "Top Management",
    "cat_id": 8
    },
    {
    "id": "30",
    "value": "Training & Development",
    "cat_id": 8
    },
    {
    "id": "19",
    "value": "Travel / Hospitality",
    "cat_id": 8
    },
    {
    "id": "49",
    "value": "Urologic Surgeon",
    "cat_id": 10
    },
    {
    "id": "48",
    "value": "Vascular Surgeon",
    "cat_id": 10
    },
    {
    "id": "32",
    "value": "Visual Merchandising",
    "cat_id": 8
    }
]

const functionalAreaHirist = [
    {
        'id': '-1',
        'name': 'Select Functional area'
    },
    {
        'id': '1',
        'name': 'Software Developer'
    },
    {
        'id': '2',
        'name': 'Technical Architect'
    },
    {
        'id': '3',
        'name': 'Project Lead / Manager'
    },
    {
        'id': '4',
        'name': 'Product Manager'
    },
    {
        'id': '5',
        'name': 'QA & Testing'
    },
    {
        'id': '6',
        'name': 'Design / Graphics'
    },
    {
        'id': '9',
        'name': 'Network Administrator'
    },
    {
        'id': '8',
        'name': 'System Administrator'
    },
    {
        'id': '10',
        'name': 'Database Administrator (DBA)'
    },
    {
        'id': '11',
        'name': 'Technical Support'
    },
    {
        'id': '12',
        'name': 'Technical Writer'
    },
    {
        'id': '13',
        'name': 'Business Analyst'
    },
    {
        'id': '14',
        'name': 'Senior Management'
    },
    {
        'id': '15',
        'name': 'Other'
    }
]

const functionalAreaUpdazz = [
    {
        'id': '-1',
        'name': 'Select Functional area'
    },
    {
        'id': '1',
        'name': 'Direct Sales',
    },
    {
        'id': '2',
        'name': 'Industrial Sales',
    },
    {
        'id': '3',
        'name': 'Business Development',
    },
    {
        'id': '4',
        'name': 'Tele Sales',
    },
    {
        'id': '5',
        'name': 'Sales Support',
    },
    {
        'id': '6',
        'name': 'Marketing / Communication',
    },
    {
        'id': '7',
        'name': 'Customer Service',
    },
    {
        'id': '9',
        'name': 'Real Estate Consultant / Agent',
    },
    {
        'id': '10',
        'name': 'Other',
    },
    {
        'id': '11',
        'name': 'Technical Support / Helpdesk',
    },
    {
        'id': '12',
        'name': 'Pharmacist/MR',
    },
    {
        'id': '13',
        'name': 'Key Account Management',
    },
    {
        'id': '14',
        'name': 'Client Servicing',
    },
    {
        'id': '15',
        'name': 'Brand Management',
    },
    {
        'id': '16',
        'name': 'Direct Marketing',
    },
    {
        'id': '17',
        'name': 'Product Management',
    },
    {
        'id': '18',
        'name': 'Retail Marketing Management',
    },
    {
        'id': '19',
        'name': 'Rural Marketing Management',
    },
    {
        'id': '20',
        'name': 'International Marketing Management',
    },
    {
        'id': '21',
        'name': 'SEO/SEM',
    },
    {
        'id': '22',
        'name': 'Email-Marketing',
    },
    {
        'id': '23',
        'name': 'PPC',
    },
    {
        'id': '24',
        'name': 'Social Media Marketing',
    },
    {
        'id': '25',
        'name': 'Display Marketing',
    },
    {
        'id': '26',
        'name': 'Graphic Designing',
    },
    {
        'id': '27',
        'name': 'Content Writing/Management',
    },
    {
        'id': '28',
        'name': 'Market Research Analytics',
    },
    {
        'id': '29',
        'name': 'PR and Media Relations',
    },
    {
        'id': '30',
        'name': 'Event Management',
    },
    {
        'id': '31',
        'name': 'Merchandising',
    },
    {
        'id': '32',
        'name': 'Business Development',
    },
    {
        'id': '33',
        'name': 'Retail-Store Mangement',
    },
    {
        'id': '34',
        'name': 'Sales Promotion Management',
    },
    {
        'id': '35',
        'name': 'Territory Management',
    },
    {
        'id': '36',
        'name': 'Sales Training',
    },
    {
        'id': '37',
        'name': 'Bval Management',
    },
    {
        'id': '38',
        'name': 'RFI/RFP Management',
    },
    {
        'id': '39',
        'name': 'Non-Tech - Team Lead',
    },
    {
        'id': '40',
        'name': 'Tech - Team Lead',
    },
    {
        'id': '41',
        'name': 'Relationship Management',
    },
    {
        'id': '42',
        'name': 'Investment Advisor',
    },
    {
        'id': '43',
        'name': 'Wealth Management',
    },
    {
        'id': '44',
        'name': 'Asset Management',
    },
    {
        'id': '45',
        'name': 'Banking/Insurance/Loan Sales'
    },
    {
        'id': '46',
        'name': 'Advertising'
    },
    {
        'id': '47',
        'name': 'IT Product & Service Sales'
    },
    {
        'id': '48',
        'name': 'Top Management ( For senior Level Positions)'
    },
    {
        'id': '49',
        'name': 'Online/Digital Marketing'
    },
    {
        'id': '50',
        'name': 'Distribution'
    }
]

const functionalAreaHiristNew = [
    {
        'id': '16',
        'value': 'Backend Development',
        'cat_id': '1',
    },
    {
        'id': '17',
        'value': 'Frontend Development',
        'cat_id': '1',
    },
    {
        'id': '18',
        'value': 'Full-Stack Development',
        'cat_id': '1',
    },
    {
        'id': '19',
        'value': 'Mobile Development - Android',
        'cat_id': '1',
    },
    {
        'id': '20',
        'value': 'Mobile Development - iOS',
        'cat_id': '1',
    },
    {
        'id': '21',
        'value': 'Mobile Development - Hybrid/Native',
        'cat_id': '1',
    },
    {
        'id': '22',
        'value': 'DevOps / Cloud',
        'cat_id': '1',
    },
    {
        'id': '23',
        'value': 'Site Reliability Engineering',
        'cat_id': '1',
    },
    {
        'id': '2',
        'value': 'Technical / Solution Architect',
        'cat_id': '1',
    },
    {
        'id': '5',
        'value': 'QA & Testing',
        'cat_id': '1',
    },
    {
        'id': '24',
        'value': 'Big Data / Data Warehousing / ETL',
        'cat_id': '1',
    },
    {
        'id': '25',
        'value': 'Embedded / Kernel Development',
        'cat_id': '1',
    },
    {
        'id': '26',
        'value': 'Other Software Development',
        'cat_id': '1',
    },
    {
        'id': '13',
        'value': 'Data Analysis / Business Analysis',
        'cat_id': '2',
    },
    {
        'id': '27',
        'value': 'Data Science',
        'cat_id': '2',
    },
    {
        'id': '28',
        'value': 'Data Mining / Analysis',
        'cat_id': '2',
    },
    {
        'id': '29',
        'value': 'Data Engineering',
        'cat_id': '2',
    },
    {
        'id': '30',
        'value': 'ML / DL Engineering',
        'cat_id': '2',
    },
    {
        'id': '31',
        'value': 'ML / DL / AI Research',
        'cat_id': '2',
    },
    {
        'id': '32',
        'value': 'Engineering Management',
        'cat_id': '3',
    },
    {
        'id': '33',
        'value': 'Release Management',
        'cat_id': '3',
    },
    {
        'id': '4',
        'value': 'Product Management',
        'cat_id': '3',
    },
    {
        'id': '3',
        'value': 'Project Management',
        'cat_id': '3',
    },
    {
        'id': '34',
        'value': 'Program Management',
        'cat_id': '3',
    },
    {
        'id': '14',
        'value': 'Senior Management',
        'cat_id': '3',
    },
    {
        'id': '35',
        'value': 'UI / UX Design',
        'cat_id': '4',
    },
    {
        'id': '36',
        'value': 'Product Design',
        'cat_id': '4',
    },
    {
        'id': '37',
        'value': 'UX Architect',
        'cat_id': '4',
    },
    {
        'id': '38',
        'value': 'Web Design',
        'cat_id': '4',
    },
    {
        'id': '39',
        'value': 'Graphic Design / Animation',
        'cat_id': '4',
    },
    {
        'id': '40',
        'value': 'Illustrator',
        'cat_id': '4',
    },
    {
        'id': '41',
        'value': 'Interaction Design',
        'cat_id': '4',
    },
    {
        'id': '42',
        'value': 'AR / VR Design',
        'cat_id': '4',
    },
    {
        'id': '43',
        'value': 'User Researcher',
        'cat_id': '4',
    },
    {
        'id': '44',
        'value': 'Other Design',
        'cat_id': '4',
    },
    {
        'id': '45',
        'value': 'Blockchain',
        'cat_id': '5',
    },
    {
        'id': '46',
        'value': 'IoT',
        'cat_id': '5',
    },
    {
        'id': '47',
        'value': 'Computer Vision',
        'cat_id': '5',
    },
    {
        'id': '48',
        'value': 'Cloud Computing',
        'cat_id': '5',
    },
    {
        'id': '49',
        'value': 'AR / VR',
        'cat_id': '5',
    },
    {
        'id': '50',
        'value': 'Cyber Security',
        'cat_id': '5',
    },
    {
        'id': '10',
        'value': 'Database Admin / Development',
        'cat_id': '6',
    },
    {
        'id': '9',
        'value': 'Network Administration',
        'cat_id': '6',
    },
    {
        'id': '8',
        'value': 'Systems Administration',
        'cat_id': '6',
    },
    {
        'id': '51',
        'value': 'Functional / Technical Consulting',
        'cat_id': '6',
    },
    {
        'id': '11',
        'value': 'Technical / Production Support',
        'cat_id': '6',
    },
    {
        'id': '52',
        'value': 'IT Management / IT Support',
        'cat_id': '6',
    },
    {
        'id': '53',
        'value': 'IT Security',
        'cat_id': '6',
    },
    {
        'id': '54',
        'value': 'IT Infrastructure Services',
        'cat_id': '6',
    },
    {
        'id': '55',
        'value': 'Networking & Wireless',
        'cat_id': '6',
    },
    {
        'id': '12',
        'value': 'Technical Writing',
        'cat_id': '6',
    },
    {
        'id': '15',
        'value': 'Other',
        'cat_id': '7',
    }
]

const functionalAreaCategory = {
    1: 'Software Engineering',
    2: 'Data Science and Analysis',
    3: 'Management',
    4: 'Design',
    5: 'Emerging Technologies & Roles',
    6: 'IT Operations and Support',
    7: 'Other',
    8: 'Management',
    9: 'Pharma',
    10: 'Healthcare',
};

export function getFunctionalArea() {
    if (process.env.REACT_APP_PLATFORM == 'iimjobs') {
        let dropdown = [];

        for (let i = 0; i < functionalAreaIimjobs.length; i++) {
            if (!dropdown[functionalAreaIimjobs[i].cat_id - 1]) {
                dropdown[functionalAreaIimjobs[i].cat_id - 1] = {
                    isCategory: true,
                    id: functionalAreaIimjobs[i].cat_id,
                    label: functionalAreaCategory[functionalAreaIimjobs[i].cat_id],
                    items: []
                }
            }

            dropdown[functionalAreaIimjobs[i].cat_id - 1].items.push({
                name: functionalAreaIimjobs[i].value,
                id: functionalAreaIimjobs[i].id,
            })
        }
        dropdown = dropdown.filter(item => item != null);
        return [
            {
                isCategory: false,
                id: '',
                value: '',
                name: 'Select Functional Area'
            },
            ...dropdown,
        ];
    }
    if(process.env.REACT_APP_PLATFORM == 'updazz')
        return functionalAreaUpdazz
    if (process.env.REACT_APP_SHOW_NEW_FUNCTIONAL_AREA_LIST == 1) {
        const dropdown = [];

        for (let i = 0; i < functionalAreaHiristNew.length; i++) {
            if (!dropdown[functionalAreaHiristNew[i].cat_id - 1]) {
                dropdown[functionalAreaHiristNew[i].cat_id - 1] = {
                    isCategory: true,
                    id: functionalAreaHiristNew[i].cat_id,
                    label: functionalAreaCategory[functionalAreaHiristNew[i].cat_id],
                    items: []
                }
            }

            dropdown[functionalAreaHiristNew[i].cat_id - 1].items.push({
                name: functionalAreaHiristNew[i].value,
                id: functionalAreaHiristNew[i].id,
            })
        }
        return [
            {
                isCategory: false,
                id: '',
                value: '',
                name: 'Select Functional Area'
            },
            ...dropdown,
        ];
    }
    return functionalAreaHirist
}

export function getFunctionalAreaMap() {

    const arr = getFunctionalArea();
    if (process.env.REACT_APP_PLATFORM == 'iimjobs' || process.env.REACT_APP_SHOW_NEW_FUNCTIONAL_AREA_LIST == 1) {
        let functionalAreaMap = {}
        for (const category of arr) {
            if (category.isCategory) {
                const aCategoryMap = category.items.reduce((prev, curr) => {
                    prev[curr.id] = curr.name;
                    return prev;
                }, {});
                functionalAreaMap = { ...functionalAreaMap, ...aCategoryMap };
            }
        }
        return functionalAreaMap;
    }
    return arr.reduce((prev, curr) => {
        prev[curr.id] = curr.name;
        return prev;
    }, {});

}

export function getFA() {
    let fa = [];
    if (process.env.REACT_APP_PLATFORM == 'iimjobs'){
        fa = functionalAreaIimjobs
    }else{
        fa = functionalAreaHirist
    }
    return fa.filter(item => item.id != -1).map(item => { 
        return {
            label: item.name,
            value: item.id.toString(),
            key: item.id,
        }
    })
}